import { Box, Typography } from '@mui/material';

import DemographicSelector from '../DemographicSelector/DemographicSelector';;

const DemographicSection = ({
  demographicData = [],
  demographicSelections = {},
  activeDemographicStep = 0,
  totalDemographicSteps = 1,
  pagination = 5,
  submitAttempted = false,
  primaryColor = '#03aae4',
  onSelectionChange,
}) => {
  const getCurrentDemographics = () => {
    const startIdx = activeDemographicStep * pagination;
    const endIdx = (activeDemographicStep + 1) * pagination;
    return demographicData.slice(startIdx, endIdx);
  };

  const hasAnySelection = () => {
    const currentDemographics = getCurrentDemographics();
    return currentDemographics.some(
      (demo) => demographicSelections[demo.demographicName]
    );
  };

  const shouldShowError = () => {
    return submitAttempted && !hasAnySelection();
  };

  const currentDemographics = getCurrentDemographics();
  const hasError = shouldShowError();

  return (
    <Box sx={{ mb: 4 }}>
      <Box
        sx={{
          border: hasError ? '2px solid #f44336' : '2px solid transparent',
          borderRadius: '8px',
          padding: hasError ? '16px' : '0px',
          transition: 'all 0.3s ease',
          backgroundColor: hasError ? 'rgba(244, 67, 54, 0.05)' : 'transparent',
        }}
      >
        <DemographicSelector
          demographicData={currentDemographics}
          onSelectionChange={onSelectionChange}
          primaryColor={primaryColor}
          value={demographicSelections}
          hasError={submitAttempted}
        />

        {hasError && (
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              color: 'error.main',
              marginTop: '1em',
              fontWeight: 'bold',
              textAlign: 'center',
            }}
          >
            Por favor, completa al menos un campo demográfico
          </Typography>
        )}
      </Box>

      {totalDemographicSteps > 1 && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            gap: '8px',
            marginTop: '16px',
          }}
        >
          {Array.from({ length: totalDemographicSteps }).map((_, index) => (
            <Box
              key={index}
              sx={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                backgroundColor:
                  index === activeDemographicStep
                    ? primaryColor
                    : 'rgba(0, 0, 0, 0.2)',
                transition: 'all 0.3s ease',
                transform:
                  index === activeDemographicStep ? 'scale(1.2)' : 'scale(1)',
              }}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};


export default DemographicSection;